/* eslint-disable react/prop-types */
import React, { useState } from 'react'
import LinkIcon from '@material-ui/icons/Link'
import CallIcon from '@material-ui/icons/Call'
import Button from '@material-ui/core/Button'
import { useNotify, usePermissions } from 'react-admin'
import authProvider from '../../../../utils/authProvider'

const MyPhonerUrl = 'https://zappyrent.myphoner.com/work/leads'
const PipedriveDealsUrl = process.env.REACT_APP_PIPEDRIVE_URL
const PropertyApi = process.env.REACT_APP_PROPERTY_API

const ToolbarButtons = ({ data }) => {
  const { permissions } = usePermissions()
  const notify = useNotify()
  const [loadingConcordato, setLoadingConcordato] = useState(false)

  const openConcordatoCalculator = async () => {
    setLoadingConcordato(true)
    try {
      const token = await authProvider.getToken()
      const response = await fetch(`${PropertyApi}/${data.property_id}/concordato-calculator-url`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      const body = await response.json().catch(() => ({}))
      if (!response.ok) {
        // The backend returns "province_required" when the property has no (or an unsupported)
        // province — guide the user to fix it instead of showing a generic error.
        if (body && body.message === 'province_required') {
          notify("Imposta l'indirizzo dell'immobile (Milano, Roma o Torino) per calcolare il canone concordato.", 'warning')
        } else {
          notify('Errore nel recupero del link per il calcolo del canone concordato', 'error')
        }
        return
      }
      window.open(body.url, '_blank', 'noopener,noreferrer')
    } catch {
      notify('Errore nel recupero del link per il calcolo del canone concordato', 'error')
    } finally {
      setLoadingConcordato(false)
    }
  }

  return (
    <>
      {data && permissions?.canGoToMyPhoner && data.my_phoner_id > 0 && (
        <Button color="primary" target="_blank" href={`${MyPhonerUrl}/${data.my_phoner_id}`} startIcon={<LinkIcon />}>
          Go to MyPhoner
        </Button>
      )}
      {data && permissions?.canGoToPipedrive && data.pipedrive_id > 0 && (
        <Button color="primary" target="_blank" href={`${PipedriveDealsUrl}/${data.pipedrive_id}`} startIcon={<CallIcon />}>
          Go to Pipedrive
        </Button>
      )}
      {data && data.property_id != null && (
        <Button color="primary" variant="outlined" onClick={openConcordatoCalculator} disabled={loadingConcordato}>
          {loadingConcordato ? 'Caricamento...' : 'Calcola Canone Concordato'}
        </Button>
      )}
    </>
  )
}

export default ToolbarButtons
